import React from 'react'
import { Input } from 'antd'

import { InputProps } from 'antd/lib/input'

/** Декоратор для `Input` от `antd`, принимает все теже `props */
export const InputControl: React.FC<InputProps> = React.memo(props => {
    return <Input {...props} />
})
